import React from 'react'
import styled from 'styled-components'

const DeathDrop = ({ name, title, value, options, onChange }) => {
  const opts = options.map(({ code, label }) => (
    <option key={code} value={code}>
      {label}
    </option>
  ))

  return (
    <div style={{ whiteSpace: 'nowrap', maxWidth: '100%' }}>
      <select
        title={title || `${name.replace(/([A-Z])/g, ' $1').replace(/^./, function(str) {
          return str.toUpperCase()
        })} (${opts.length} Options)`}
        style={{
          width: value && value.length > 0 ? '180px' : '95%',
          overflowWrap: 'unset',
          margin: '.5em',
        }}
        value={value}
        name={name}
        onChange={onChange}
      >
        <option key={0} value="">
          {value
            ? 'Reset Selection'
            : title || `${name
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, str => str.toUpperCase())} (${opts.length})`}
        </option>
        {opts}
      </select>
      {value && value.length > 0 && (
        <Reset title="Undo" value={''} name={name} onClick={onChange}>
          ⎌
        </Reset>
      )}
    </div>
  )
}

export default DeathDrop

export const Reset = styled.button`
  background-color: #fff; /* Green */
  border: 1px solid #ccc;
  border-radius: 5px;
  color: black;
  padding: 0px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 18px;
  &:hover {
    box-shadow: 1px 1px;
  }
`
